
import { Component, Vue, Prop } from 'vue-property-decorator';
import CardLavorazione from './CardLavorazione.vue';
import { LavorazioneSlim } from '@/models';

@Component({
  components: { 
      CardLavorazione 
    }
})
export default class LavrazioniCards extends Vue {
    @Prop() private lavorazioni!: LavorazioneSlim[];
    @Prop({ default: false }) private compact!: boolean;
}
